import { Link } from 'react-router-dom';
import { User, ArrowRight } from 'lucide-react';

const nomStagiaire = (d, stagiaires) => {
  const s = stagiaires.find(x => x.user_id === d.stagiaire_id);
  return d.stagiaire_nom || (s && `${s.user_info?.prenom || s.prenom || ''} ${s.user_info?.nom || s.nom || ''}`.trim()) || 'Stagiaire';
};

export const AbsencesEnAttente = ({ demandes, stagiaires = [] }) => (
  <div className="bg-white border border-slate-200 rounded-xl p-4 sm:p-6 shadow-sm space-y-3" data-testid="absences-en-attente">
    {demandes.length === 0 ? (
      <p className="text-sm text-slate-500">Aucune demande d'absence en attente.</p>
    ) : demandes.map((d, i) => (
      <div key={d.demande_id || i} className="flex items-center gap-3 p-3 bg-orange-50 rounded-lg border border-orange-200">
        <User className="h-5 w-5 text-orange-500 shrink-0" />
        <div className="min-w-0">
          <p className="font-medium text-[#0F172A] text-sm">{nomStagiaire(d, stagiaires)}</p>
          <p className="text-xs text-slate-600 truncate">{new Date(d.date).toLocaleDateString('fr-FR')} — {d.motif}</p>
        </div>
      </div>
    ))}
    <Link to="/demandes-absence" className="inline-flex items-center gap-1.5 text-sm font-medium text-[#8DC63F] hover:underline" data-testid="absences-gerer-lien">
      Gérer les demandes d'absence <ArrowRight className="h-4 w-4" />
    </Link>
  </div>
);
